// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "7e7db6fecd0db25f821fa16796c2d356a43cee3f/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};